<template>
  <el-row :key="updateKey">
    <el-col :span="24">
      <el-form-item label="宽度">
        <el-input-number
          v-model="layoutConfig.w"
          :controls="false"
          :min="10"
          :max="layoutWidth - layoutConfig.x"
          class="w-full"
          @change="(curVal, oldVal) => numChange('w', curVal, oldVal)"
        />
      </el-form-item>
      <el-form-item label="高度">
        <el-input-number
          v-model="layoutConfig.h"
          :controls="false"
          :min="10"
          class="w-full"
          @change="(curVal, oldVal) => numChange('h', curVal, oldVal)"
        />
      </el-form-item>
      <el-form-item label="x">
        <el-input-number
          v-model="layoutConfig.x"
          :controls="false"
          :min="0"
          :max="layoutWidth - layoutConfig.w"
          class="w-full"
          @change="(curVal, oldVal) => numChange('x', curVal, oldVal)"
        />
      </el-form-item>
      <el-form-item label="y">
        <el-input-number
          v-model="layoutConfig.y"
          :controls="false"
          :min="0"
          class="w-full"
          @change="(curVal, oldVal) => numChange('y', curVal, oldVal)"
        /> </el-form-item
    ></el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          w: 10,
          h: 10,
          x: 0,
          y: 0,
        }
      },
    },
    layoutWidth: {
      type: Number,
      default: window.innerWidth,
    },
    layout: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      layoutConfig: {},
      updateKey: _.random(5000),
    }
  },
  watch: {
    config: {
      deep: true,
      handler(val) {
        this.layoutConfig = _.cloneDeep(val)
      },
    },
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    },
  },
  methods: {
    // 判断拖拽元素是否与布局元素碰撞
    isInRange() {
      const domRange = {
        x: this.layoutConfig.x,
        x1: this.layoutConfig.x + this.layoutConfig.w,
        y: this.layoutConfig.y,
        y1: this.layoutConfig.y + this.layoutConfig.h,
        i: this.layoutConfig.i,
      }
      const inRange = _.findIndex(this.layout, (item) => {
        if (item.i === domRange.i) return false
        const xInRange =
          (domRange.x >= item.x && domRange.x <= item.x + item.w) ||
          (domRange.x1 >= item.x && domRange.x1 <= item.x + item.w) ||
          (item.x >= domRange.x && item.x <= domRange.x1) ||
          (item.x + item.w >= domRange.x && item.x + item.w <= domRange.x1)
        const yInRange =
          (domRange.y >= item.y && domRange.y <= item.y + item.h) ||
          (domRange.y1 >= item.y && domRange.y1 <= item.y + item.h) ||
          (item.y >= domRange.y && item.y <= domRange.y1) ||
          (item.y + item.h >= domRange.y && item.y + item.h <= domRange.y1)
        return xInRange && yInRange
      })
      return inRange > -1
    },
    numChange(key, curVal, oldVal) {
      if (!_.isNumber(curVal)) {
        this.$set(this.layoutConfig, key, oldVal)
        this.updateKey = _.random(5000)
        return
      }
      const inRange = this.isInRange()
      if (inRange) {
        this.$set(this.layoutConfig, key, oldVal)
        this.updateKey = _.random(5000)
      } else {
        this.$emit('layoutChange', this.layoutConfig)
      }
    },
  },
  mounted() {
    this.layoutConfig = _.cloneDeep(this.config)
  },
}
</script>

<style></style>
